document.addEventListener('DOMContentLoaded', function () {

  /* =================================
     FEATURE BAR — RESPONSIVE TEXT
     ================================= */

  const featureBar = document.querySelector(
    '.gr-below-nav .sub_menu'
  );
  if (featureBar) {
    function resizeFeatureText() {
      const items = featureBar.querySelectorAll('li');
      if (!items.length) return;
      const itemWidth =
        items[0].getBoundingClientRect().width;
      let titleSize = Math.min(13, itemWidth / 9);
      let textSize = Math.min(11, itemWidth / 10);
      titleSize = Math.max(8, titleSize);
      textSize = Math.max(7, textSize);
      featureBar.querySelectorAll('.feature-title')
        .forEach(function (el) {
          el.style.setProperty(
            'font-size',
            titleSize + 'px',
            'important'
          );
        });
      featureBar.querySelectorAll(
        '.feature-link, .feature-text'
      ).forEach(function (el) {
        el.style.setProperty(
          'font-size',
          textSize + 'px',
          'important'
        );
      });
    }
    resizeFeatureText();
    if (window.ResizeObserver) {
      new ResizeObserver(
        resizeFeatureText
      ).observe(featureBar);
    } else {
      window.addEventListener(
        'resize',
        resizeFeatureText
      );
    }
  }

  /* =================================
     COLLECTION — SOCIAL ICONS
     ================================= */

  const socialBar = document.querySelector(
    'body.templateCollection .top-below-nav .social'
  );
  if (socialBar) {
    const socialStyle = document.createElement('style');
    socialStyle.textContent = `
      body.templateCollection .top-below-nav .social ul{
        display:flex!important;
        flex-wrap:nowrap!important;
        align-items:center!important;
        justify-content:center!important;
        width:100%!important;
        height:50px!important;
        margin:0!important;
        padding:0!important;
      }
      body.templateCollection .top-below-nav .social ul li{
        float:none!important;
        display:flex!important;
        flex:0 0 50%!important;
        width:50%!important;
        height:50px!important;
        margin:0!important;
        padding:0!important;
        align-items:center!important;
        justify-content:center!important;
        box-sizing:border-box!important;
      }
      body.templateCollection .top-below-nav .social ul li img{
        display:block!important;
        width:100%!important;
        max-width:100%!important;
        height:auto!important;
        object-fit:contain!important;
      }
    `;
    document.head.appendChild(socialStyle);
  }

  /* =================================
     FOOTER — REMOVE DESIGN SHOPIFY
     ================================= */

  function removeDesignShopify() {
    const copyright = document.querySelector('.copyright');
    if (!copyright) return;
    const link = copyright.querySelector(
      'a[href*="designshopify"]'
    );
    if (!link) return;
    const br = link.previousElementSibling;
    if (br && br.tagName === 'BR') {
      br.remove();
    }
    const textNode = link.previousSibling;
    if (
      textNode &&
      textNode.nodeType === Node.TEXT_NODE
    ) {
      textNode.textContent =
        textNode.textContent.replace(
          /Designed by\s*$/i,
          ''
        );
    }
    link.remove();
  }
  removeDesignShopify();

  /* =================================
     PRODUCT — SOCIAL ICONS
     ================================= */

  const productSocialBar = document.querySelector(
    'body.templateProduct .top-below-nav .social'
  );
  if (productSocialBar) {
    const productSocialStyle =
      document.createElement('style');
    productSocialStyle.textContent = `
      body.templateProduct .top-below-nav .social ul{
        display:flex!important;
        flex-wrap:nowrap!important;
        align-items:center!important;
        justify-content:center!important;
        width:100%!important;
        height:50px!important;
        margin:0!important;
        padding:0!important;
      }
      body.templateProduct .top-below-nav .social ul li{
        float:none!important;
        display:flex!important;
        flex:0 0 50%!important;
        width:50%!important;
        height:50px!important;
        margin:0!important;
        padding:0!important;
        align-items:center!important;
        justify-content:center!important;
        box-sizing:border-box!important;
      }
      body.templateProduct .top-below-nav .social ul li img{
        display:block!important;
        width:100%!important;
        max-width:100%!important;
        height:auto!important;
        object-fit:contain!important;
      }
    `;
    document.head.appendChild(productSocialStyle);
  }

/* =================================
   REMOVE WELCOME BOX
   ================================= */

function removeWelcomeBox() {
  document.querySelectorAll(
    '.sb-title.box.text_widget'
  ).forEach(function(el) {
    if (el.textContent.trim() === 'Welcome') {
      el.remove();
    }
  });
}
removeWelcomeBox();
if (window.MutationObserver) {
  new MutationObserver(function() {
    removeWelcomeBox();
  }).observe(document.body, {
    childList:true,
    subtree:true
  });
}

   /* =================================
     PRODUCT — MAIN IMAGE ARROWS
     ================================= */

  function setupProductImageArrows() {
    const gallery = document.querySelector(
      'body.templateProduct #gallery_main'
    );
    if (!gallery) return;
    /* PREVENT THE FUNCTION BEING ATTACHED TWICE */
    if (gallery.dataset.mainArrowsReady === 'true') {
      return;
    }
    const previous = gallery.querySelector(
      '.owl-prev'
    );
    const next = gallery.querySelector(
      '.owl-next'
    );
    const controls = gallery.querySelector(
      '.owl-controls'
    );
    if (!previous || !next) return;
    /*
     * ONLY USE THE REAL PRODUCT THUMBNAILS.
     * KEEP THEIR ORIGINAL LEFT-TO-RIGHT ORDER.
     */
    const thumbnails = Array.from(
      gallery.querySelectorAll(
        '.owl-item:not(.cloned) .image-thumb'
      )
    );
    if (!thumbnails.length) return;
    gallery.dataset.mainArrowsReady = 'true';
    /* HIDE ARROWS IF ONLY ONE IMAGE */
    if (thumbnails.length < 2) {
      if (controls) {
        controls.style.setProperty(
          'display',
          'none',
          'important'
        );
      }
      return;
    }
    /* SHOW ARROWS */
    if (controls) {
      controls.style.setProperty(
        'display',
        'block',
        'important'
      );
    }
    /* FIND CURRENT IMAGE */
    function getCurrentIndex() {
      const active = gallery.querySelector(
        '.image-thumb.active'
      );
      if (!active) return 0;
      const activeImage =
        active.closest('.owl-item');
      const index =
        thumbnails.findIndex(function(item) {
          return item.closest('.owl-item') ===
            activeImage;
        });
      return index >= 0 ? index : 0;
    }
    /* PREVIOUS */
    previous.addEventListener(
      'click',
      function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const currentIndex =
          getCurrentIndex();
        const newIndex =
          currentIndex === 0
            ? thumbnails.length - 1
            : currentIndex - 1;
        thumbnails[newIndex].click();
      },
      true
    );
  /* NEXT */
    next.addEventListener(
      'click',
      function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const currentIndex =
          getCurrentIndex();
        const newIndex =
          currentIndex === thumbnails.length - 1
            ? 0
            : currentIndex + 1;
        thumbnails[newIndex].click();
      },
      true
    );
  }
  setupProductImageArrows();
setTimeout(
  setupProductImageArrows,
  100
);
  /* =================================
   PRODUCT — PREMIUM IMAGE LIGHTBOX
   ================================= */

const mainImage =
  document.querySelector(
    'body.templateProduct #product-featured-image'
  );
const galleryImages =
  Array.from(
    document.querySelectorAll(
      'body.templateProduct .image-thumb'
    )
  );
if(mainImage && galleryImages.length){
  let currentImage = 0;
  const lightbox =
    document.createElement('div');
  lightbox.className =
    'product-lightbox';
  lightbox.innerHTML = `
    <div class="product-lightbox-close">
      ×
    </div>
    <div class="product-lightbox-prev">
      ‹
    </div>
    <img>
    <div class="product-lightbox-next">
      ›
    </div>
  `;
  document.body.appendChild(lightbox);
  const lightboxImage =
    lightbox.querySelector('img');
  function showImage(index){
    currentImage = index;
    lightboxImage.src =
      galleryImages[index]
      .dataset.zoomImage;
  }
  mainImage.addEventListener(
    'click',
    function(event){
      event.preventDefault();
      showImage(
        currentImage
      );
      lightbox.classList.add(
        'active'
      );
    }
  );
  galleryImages.forEach(
    function(item,index){
      item.addEventListener(
        'click',
        function(){
          currentImage=index;
        }
      );
    }
  );
  lightbox.querySelector(
    '.product-lightbox-close'
  )
  .onclick=function(){
    lightbox.classList.remove(
      'active'
    );
  };
  lightbox.querySelector(
    '.product-lightbox-next'
  )
  .onclick=function(){
    currentImage++;
    if(
      currentImage >= galleryImages.length
    ){
      currentImage=0;
    }
    showImage(currentImage);
  };
  lightbox.querySelector(
    '.product-lightbox-prev'
  )
  .onclick=function(){
    currentImage--;
    if(
      currentImage < 0
    ){
      currentImage =
        galleryImages.length-1;
    }
    showImage(currentImage);
  };
  lightbox.onclick=function(event){
    if(
      event.target === lightbox
    ){
      lightbox.classList.remove(
        'active'
      );
    }
  };
}
});
